import _ from 'lodash'
import React from 'react'
import T from 'prop-types'

export default class DataTableRow extends React.Component {
  static displayName = 'DataTableRow'

  static propTypes = {
    children: T.arrayOf(T.node),
    className: T.string,
    'data-rowIndex': T.number,
    onClick: T.func,
    onDoubleClick: T.func,
    selectableKey: T.oneOfType([T.string, T.number]) // For DragSelectionContainer
  }

  render() {
    const { props } = this
    return (
      <tr
        {..._.pick(props, [
          'className',
          'data-rowIndex',
          'onClick',
          'onDoubleClick'
        ])}
      >
        {props.children}
      </tr>
    )
  }
}
